<template>
    <div v-if="note" class="note-view" >
        
        <div id="header">
            <div class="header-row title-row">
                <div class="text-button" @click="back">Cancel</div>
                <span>Create your note</span>
                <div class="text-button" @click="createNote">Create</div>
            </div>
        </div>
       
        <!-- Note editor and viewer -->
        <div class="content">
            <input ref="note_title_input" 
                type="text"
                class="note-title-input" 
                v-model="new_note.title"
                placeholder="Name your note:"
                @keydown.enter="createNote"
            >

            <span v-if="parent_folder">Your note will be created within the 
                <span class="parent-folder-name">{{parent_folder.name}}</span>
                Folder
            </span>
        </div>
    </div>
</template>

<script>

import _ from 'lodash';


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export default {
    data(){
        return {
            new_note : {
                title: null,
                aliases: [],
            },
        }
    },

    mounted(){
        this.$refs.note_title_input.focus();  
    },

    methods:{
        back() {
            window.history.back();
        },

        createNote(){
            if(this.note.title?.length) {
                this.$store.dispatch('addNoteToWorkspace', this.note).then( note =>{
                    this.note_title_input = '';
                    this.$router.push({
                        path:`/${note.workspace}/notes/${note.slug}`
                    });
                });   
            }
            
            else {
                this.$store.dispatch("showError", "Note title must not be blank.");
            }
        },

        saveNote: _.debounce(
            function(val) {
                this.$store.dispatch('updateNote', {...this.note, title: val}).then(updatedNote => {
                    this.$router.push(`/${this.$route.workspace_route}/notes/${updatedNote.slug}/edit`)
                });
        }, 300),
    },

    computed : {
        note(){
            return {
                ...this.new_note,
                workspace_slug: this.current_workspace.slug,
                parent_slug: this.parent_folder_slug,
            }
        },

        editing_disabled () {
            return !this.new_note?.title;
        },

        current_workspace() {
            return this.$store.getters.current_workspace;
        },

        parent_folder_slug() {
            return this.$route.query.parent_slug;
        },

        parent_folder() {
            return this.$store.getters.folder_with_slug(this.parent_folder_slug);
        },

        folders() {
            return this.$store.getters.folders;
        },

        isMobile() {
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        },

        note_view_mode() {
            return this.$store.state.ui.note_view_mode;
        },

        editing() {
            return this.note_view_mode === 'edit';
        },
    },
}
</script>

<style lang="sass" scoped>
    @import "../assets/colors.sass"
    .note-view
        padding: 10px
        padding: 0px
        display: flex
        flex-direction: column
        justify-content: flex-start
        height: 100%
        min-height: 0
        overflow: hidden
        position: relative


    .content
        display: flex
        flex-direction: column
        overflow: hidden
        flex: 1

    #header 
        display: flex
        flex-direction: column
        padding: 0 20px
        border-bottom: 1px solid $border-medium

    .title-row 
        flex-basis: 60px

    .header-row
        width: 100%
        flex-grow: 0
        flex-shrink: 0

        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        flex-wrap: nowrap
        background-color: inherit
        span
            flex: 1
            white-space: nowrap
            min-width: 100px
            display: block
            overflow: hidden
    
    i.icon-button.action
        margin: 0px 5px

    .note-title-input
        flex: 0
        margin: 10px 10px
        font-size: 2em
        height: 45px
        font-family: 'Roboto Slab'
        font-weight: 300
        box-sizing: border-box
        text-align: center
        border: 1px dashed $border-medium
        box-shadow: $mini-shadow
        padding: 5px
        
        &:focus
            border-color: $border-light
        &:active, &:active:focus
            border-color: lighten($border-light, 5%)
    
    .flat-icon-button
        margin-left: 5px

</style>